import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ArticleTeaser from '../../elements/article_teaser'
import {
    Alignment,
    Breadcrumb,
    Button,
    Classes,
    H5,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    Switch,
} from "@blueprintjs/core";
import {withRouter} from 'react-router';
import DATA from '../../../data/article_data'

class Article extends Component {
    constructor(props){
        super(props);
        //console.log(props,this.state)
        this.state = { 
            feature_article:{
                "name":"",
                "teaser":"",
                "source": "", 
                "link":"",
                "status":"",
                "full_article":"",
                "image":"",
            },
            blog_data : DATA.blog_data,
            articles: DATA.articles,
        }
    };

    componentDidMount () {
        const { articleId } = this.props.match.params
        console.log('id = ', articleId)
        /*
        fetch(`https://api.twitter.com/user/${handle}`)
          .then((user) => {
            this.setState(() => ({ user }))
          })
          */
         this.setState({
             feature_article: this.state.articles[articleId]
         });
      }

    // data = [{title:"demo",},{title:"demo",},{title:"demo",}]

    items = DATA.articles.map(item => {
        return <ArticleTeaser id={item.id} name={item.title} teaser={item.teaser} source={item.source} link={item.link} image={item.image}/>;
    });

  render() {
    return (
        <div className="blog_page_article_wrapper">
            <img src={this.state.articles[this.props.match.params.articleId].image } className="full_article_image"/>
            <h3 className="blog_page_article_title">{this.state.articles[this.props.match.params.articleId].title}</h3>
            <div className="full_article_text" dangerouslySetInnerHTML={{__html: this.state.articles[this.props.match.params.articleId].full_article}}>
            </div>
        </div>
    );
  }
}

export default withRouter(Article);